<template lang="pug">
swiper(ref="sw" :options="swiperOptions" @slideChange="handleSlideChange")
  //- small {{ details['kns'] }}
  template(v-if="isShow")
    swiper-slide
      .odds-wrapper
        .odds-group
          .m-label-top {{ $tc("m.BT_HDPF", 2) }}
          .m-label-top {{ $tc("m.BT_OUF", 2) }}
          .m-label-top {{ $tc("m.BT_OEF", 2) }}
          template(v-if="details['hdp'] && details['hdp'][0] && details['hdp'][0][9] != 0 && details['hdp'][0][10] != 0 && details['hdp'][0][9] != '' && details['hdp'][0][10] != ''")
            OddsItem(:odds="details['hdp'][0]" :idx="details['hdp'][0][7] == 1 ? '10' : '9'" :typ="oddsType" dataType="1" mode="hdp" :count="0" :details="details" homeAway="1")
          template(v-else)
            OddsDisabled
          template(v-if="details['ou'] && details['ou'][0] && details['ou'][0][11] != 0 && details['ou'][0][12] != 0 && details['ou'][0][11] != '' && details['ou'][0][12] != ''")
            OddsItem(:odds="details['ou'][0]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="over" :count="0" :details="details" homeAway="1")
          template(v-else)
            OddsDisabled
          template(v-if="details['oe'] && details['oe'][0] && details['oe'][0][5] != 0 && details['oe'][0][5] != ''")
            OddsItem(:odds="details['oe'][0]" idx=5 :typ="oddsType" dataType="2" mode="oe" homeAway="1" :details="details")
          template(v-else)
            OddsDisabled

          template(v-if="details['hdp'] && details['hdp'][0] && details['hdp'][0][9] != 0 && details['hdp'][0][10] != 0 && details['hdp'][0][9] != '' && details['hdp'][0][10] != ''")
            OddsItem(:odds="details['hdp'][0]" :idx="details['hdp'][0][7] == 1 ? '9' : '10'" :typ="oddsType" dataType="1" mode="hdp" :count="0" :details="details" homeAway="2")
          template(v-else)
            OddsDisabled
          template(v-if="details['ou'] && details['ou'][0] && details['ou'][0][11] != 0 && details['ou'][0][12] != 0 && details['ou'][0][11] != '' && details['ou'][0][12] != ''")
            OddsItem(:odds="details['ou'][0]" idx=11 :typ="oddsType" dataType="1" mode="ou" label="under" :count="0" :details="details" homeAway="2")
          template(v-else)
            OddsDisabled
          template(v-if="details['oe'] && details['oe'][0] && details['oe'][0][7] != 0 && details['oe'][0][7] != ''")
            OddsItem(:odds="details['oe'][0]" idx=7 :typ="oddsType" dataType="2" mode="oe" homeAway="2" :details="details")
          template(v-else)
            OddsDisabled

          .more-market-btn.grid3(@click="toggleMoreMarkets") {{ $t("ui.more_hdp_markets") }}
    template(v-if="details['hdph'] || details['ouh'] || details['oeh']")
      swiper-slide
        template(v-if="activeIndex == 1")
          .odds-wrapper
            .odds-group
              .m-label-top {{ $tc("m.BT_HDPH", 2) }}
              .m-label-top {{ $tc("m.BT_OUH", 2) }}
              .m-label-top {{ $tc("m.BT_OEH", 2) }}
              template(v-if="details['hdph'] && details['hdph'][0] && details['hdph'][0][9] != 0 && details['hdph'][0][10] != 0 && details['hdph'][0][9] != '' && details['hdph'][0][10] != ''")
                OddsItem(:odds="details['hdph'][0]" :idx="details['hdph'][0][7] == 1 ? '10' : '9'" :typ="oddsType" dataType="1" mode="hdph" :count="0" :details="details" homeAway="1")
              template(v-else)
                OddsDisabled
              template(v-if="details['ouh'] && details['ouh'][0] && details['ouh'][0][11] != 0 && details['ouh'][0][12] != 0 && details['ouh'][0][11] != '' && details['ouh'][0][12] != ''")
                OddsItem(:odds="details['ouh'][0]" idx=12 :typ="oddsType" dataType="1" mode="ouh" label="over" :count="0" :details="details" homeAway="1")
              template(v-else)
                OddsDisabled
              template(v-if="details['oeh'] && details['oeh'][0] && details['oeh'][0][5] != 0 && details['oeh'][0][5] != ''")
                OddsItem(:odds="details['oeh'][0]" idx=5 :typ="oddsType" dataType="2" mode="oeh" homeAway="1" :details="details")
              template(v-else)
                OddsDisabled

              template(v-if="details['hdph'] && details['hdph'][0] && details['hdph'][0][9] != 0 && details['hdph'][0][10] != 0 && details['hdph'][0][9] != '' && details['hdph'][0][10] != ''")
                OddsItem(:odds="details['hdph'][0]" :idx="details['hdph'][0][7] == 1 ? '9' : '10'" :typ="oddsType" dataType="1" mode="hdph" :count="0" :details="details" homeAway="2")
              template(v-else)
                OddsDisabled
              template(v-if="details['ouh'] && details['ouh'][0] && details['ouh'][0][11] != 0 && details['ouh'][0][12] != 0 && details['ouh'][0][11] != '' && details['ouh'][0][12] != ''")
                OddsItem(:odds="details['ouh'][0]" idx=11 :typ="oddsType" dataType="1" mode="ouh" label="under" :count="0" :details="details" homeAway="2")
              template(v-else)
                OddsDisabled
              template(v-if="details['oeh'] && details['oeh'][0] && details['oeh'][0][7] != 0 && details['oeh'][0][7] != ''")
                OddsItem(:odds="details['oeh'][0]" idx=7 :typ="oddsType" dataType="2" mode="oeh" homeAway="2" :details="details")
              template(v-else)
                OddsDisabled

              .more-market-btn.grid3(@click="toggleMoreMarkets") {{ $t("ui.more_hdp_markets") }}
  .swiper-pagination(v-show="hasSecondSlide" slot="pagination")


//- div
//-   swiper(ref="sw" :options="swiperOptions" @slideChange="handleSlideChange")
//-     swiper-slide.match-marketgroup-content(:class="(source.marketId == 3) ? 'live' : ''")
//-       .match-bet-area-group.flex-grow-2
//-         hdpItem(:details="details" :oddsType="oddsType" betType="hdp" homeAway="1")
//-       .match-bet-area-group.flex-grow-2
//-         ouItem(:details="details" :oddsType="oddsType" betType="ou")
//-       .match-bet-area-group.flex-grow-1
//-         oeItem(:details="details" :oddsType="oddsType" betType="oe")
//-     template(v-if="source.details.hdph || source.details.ouh || source.details.oeh")
//-       swiper-slide.match-marketgroup-content(:class="(source.marketId == 3) ? 'live' : ''")
//-         template(v-if="activeIndex == 1")
//-           .match-bet-area-group.flex-grow-2
//-             hdpItem(:details="details" :oddsType="oddsType" betType="hdph" homeAway="2")
//-           .match-bet-area-group.flex-grow-2
//-             ouItem(:details="details" :oddsType="oddsType" betType="ouh")
//-           .match-bet-area-group.flex-grow-1
//-             oeItem(:details="details" :oddsType="oddsType" betType="oeh")
//-     .swiper-pagination(slot="pagination")
</template>

<script>
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  data() {
    return {
      activeIndex: 0,
      isShow: false,
      showing: 10
    };
  },
  computed: {
    hasSecondSlide() {
      return !!(this.details && (this.details['hdph'] || this.details['ouh'] || this.details['oeh']));
    },
    swiperOptions() {
      const hasOnlyOneSlide = !this.hasSecondSlide;
      const self = this;
      return {
        slidesPerView: 1,
        spaceBetween: 0,
        allowTouchMove: !hasOnlyOneSlide,
        simulateTouch: true,
        touchRatio: 1,
        touchAngle: 45,
        threshold: 5,
        resistance: true,
        resistanceRatio: 0.85,
        observer: true,
        observeParents: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: (index, className) => {
            return '<span class="' + className + '"></span>';
          }
        },
        on: {
          init: function() {
            self.handleSwiperInit();
          }
        }
      };
    },
    swiper() {
      return this.$refs.sw ? this.$refs.sw.$swiper : 0;
    }
  },
  watch: {
    hasSecondSlide(newVal) {
      this.$nextTick(() => {
        if (this.swiper && this.swiper.params) {
          this.swiper.allowTouchMove = newVal;
          this.swiper.update();
        }
      });
    },
    isShow(newVal) {
      if (newVal && this.swiper) {
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.swiper) {
              if (this.swiper.params) {
                this.swiper.allowTouchMove = this.hasSecondSlide;
              }
              this.swiper.update();
              if (this.swiper.pagination && this.hasSecondSlide) {
                this.swiper.pagination.render();
                this.swiper.pagination.update();
              }
            }
          }, 100);
        });
      }
    }
  },
  mounted() {
    if (this.source.matchIndex <= this.showing) {
      this.isShow = true;
    } else {
      setTimeout(() => {
        this.isShow = true;
      }, this.source.matchIndex * 25);
    }
    this.$nextTick(() => {
      setTimeout(() => {
        if (this.swiper) {
          this.activeIndex = this.swiper.activeIndex;
          if (this.swiper.params) {
            this.swiper.allowTouchMove = this.hasSecondSlide;
          }
          if (this.swiper.pagination && this.isShow) {
            this.swiper.pagination.render();
            this.swiper.pagination.update();
          }
        }
      }, 150);
    });
  },
  methods: {
    toggleMoreMarkets() {
      this.$emit('toggle-more-markets');
    },
    handleSlideChange() {
      this.activeIndex = this.swiper.activeIndex;
    },
    handleSwiperInit() {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.swiper) {
            if (this.swiper.params) {
              this.swiper.allowTouchMove = this.hasSecondSlide;
            }
            this.swiper.update();
            if (this.swiper.pagination && this.hasSecondSlide) {
              this.swiper.pagination.render();
              this.swiper.pagination.update();
            }
          }
        }, 200);
      });
    }
  }
};
</script>